<template>
  <v-row>
    <v-col :lg="5" :md="5">
      <v-card class="app-card app-card--custom">
        <v-card-title class="app-card-title mb-0">
          <h4 class="text">
            <v-icon>shopping_basket</v-icon>
            <span>Detalhes</span>
          </h4>
        </v-card-title>
        <v-card-text class="app-card-content mt-3">
          <PaymentDetalhe
            :paymentDetailProducts="paymentProducts"
            :total="sumTotal()"
          />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col :lg="7" :md="7" >
      <v-expansion-panels v-if="!form.message.active" accordion class="app-expansion">
        <v-expansion-panel class="app-expansion-panel">
          <v-expansion-panel-header class="app-expansion-panel-header">
            <h4 class="text">
              <v-icon>credit_card</v-icon>
              <span>Pagamento Cartão</span>
            </h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <PaymentCartao
              :paymentCartaoIndendificationNumber="
                paymentProductOwnerIdentification
              "
              :paymentCartaoIndendificationValue="sumTotal()"
              :idPedidos="idPedidos"
              @doPayment="doPayment"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="app-expansion-panel">
          <v-expansion-panel-header class="app-expansion-panel-header">
            <h4 class="text">
              <v-icon>request_quote</v-icon>
              <span>Pagamento Boleto</span>
            </h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <PaymentBoleto
              :paymentCartaoIndendificationNumber="
                paymentProductOwnerIdentification
              "
              :paymentCartaoIndendificationValue="sumTotal()"
              :idPedidos="idPedidos"
              @doPayment="doPayment"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="app-expansion-panel">
          <v-expansion-panel-header class="app-expansion-panel-header">
            <h4 class="text">
              <img
                src="../../assets/images/pix.svg"
                alt="img-pix"
                width="22px"
                height="22px"
              />
              <span>Pagamento Pix</span>
            </h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <PaymentPix
              :paymentCartaoIndendificationNumber="
                paymentProductOwnerIdentification
              "
              :paymentCartaoIndendificationValue="sumTotal()"
              :idPedidos="idPedidos"
              @doPayment="doPayment"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <MessageVue></MessageVue>
    </v-col>
  </v-row>
</template>

<script>
import PaymentDetalhe from "@/components/PaymentGroup/PaymentDetalhe";
import PaymentBoleto from "@/components/PaymentGroup/PaymentBoleto";
import PaymentCartao from "@/components/PaymentGroup/PaymentCartao";
import PaymentPix from "@/components/PaymentGroup/PaymentPix";
import MessageVue from "@/views/autovistoria/components/Message.vue";
import { mapState } from 'vuex';

export default {
  name: "PaymentForm",
  props: {
    paymentProducts: {
      type: Array,
      required: true,
    },
    paymentProductOwnerIdentification: {
      type: String,
      required: true,
      default: "",
    },
    paymentProductValue: {
      type: Number,
      required: true,
      default: 0,
    },
    idPedidos: {
      type: Array,
      required: true,
    },
  },
  components: {
    PaymentDetalhe,
    PaymentBoleto,
    PaymentCartao,
    PaymentPix,
    MessageVue,
  },
  computed: {
    ...mapState("autovistoria", ["form"]),
  },
  methods: {
    doPayment(value) {
      this.$emit("doPayment", value);
    },
    sumTotal() {
      const totalValue = this.paymentProducts.reduce(
        (accumulator, currentValue) =>
          accumulator + parseFloat(currentValue.typeSolicitation.value),
        0
      );
      return totalValue;
    },
  },
};
</script>
